/**
 * Vendor Template Form Logic
 *
 * Views: vendors/index
 */

if ($('#vendor_template_modal').length) {
    var template_media_type;
    var template_market;
    var template_vendor;
    var template_vendor_data;
    var map;

    $('#template_media_type').select2({
        placeholder: "Select One",
        minimumResultsForSearch: -1
    }).on('select2:select', function () {
        template_media_type = $(this).val();

        if (template_media_type !== "") {
            vendor_template_media_type_change($(this));
        }
    });
    $(".select2-selection.select2-selection--multiple:not(:has(i.fa.fa-search.search-icon-input))").prepend("<i class='fa fa-search search-icon-input'></i>")

    var vendor_template_media_type_change = function (select) {
        show_overlay_loader('#vendor_template_modal .modal-content');

        vendor_template_clear_tv_template();

        $('#template_market').html('').hide();
        $('#template_vendor').html('').hide();

        $.ajax({
            type: 'GET',
            url: 'vendor/template/' + template_media_type + '/markets',
            dataType: 'json',
            encode: true,
            success: function (data) {

                $('#template_market').html('').append('<option value=""></option>');

                $.each(data, function (index, value) {
                    $('#template_market').append('<option value="' + value['slug'] + '">' + value['name'] + "</option>")
                });

                if ($('#template_market').data('select2')) {
                    $('#template_market').data('select2').destroy();
                }

                $('#template_market').select2({
                    placeholder: "Select One",
                   // minimumResultsForSearch: -1
                });
                $(".select2-selection.select2-selection--multiple:not(:has(i.fa.fa-search.search-icon-input))").prepend("<i class='fa fa-search search-icon-input'></i>")

                $('#template_market_container').show();

                $('#template_market').bind('select2:select', function () {
                    template_market = $(this).val();

                    if (template_market !== "") {
                        vendor_template_market_change($(this));
                    }
                });

                hide_overlay_loader('#vendor_template_modal .modal-content');
            },
            error: function (xhr) {
                ajax_error();
                debug(xhr.responseText);

                hide_overlay_loader('#vendor_template_modal .modal-content');
            }
        });
    };

    var vendor_template_market_change = function (select) {
        show_overlay_loader('#vendor_template_modal .modal-content');

        vendor_template_clear_tv_template();

        $('#template_vendor').html('').hide();

        $.ajax({
            type: 'GET',
            url: 'vendor/template/' + template_market,
            dataType: 'json',
            encode: true,
            success: function (data) {
                $('#template_vendor').html('').append('<option value=""></option>');

                $.each(data, function (index, value) {
                    $('#template_vendor').append('<option value="' + value['id'] + '">' + value['callsign'] + "</option>")
                });

                if ($('#template_vendor').data('select2')) {
                    $('#template_vendor').data('select2').destroy();
                }

                $('#template_vendor').select2({
                    placeholder: "Select One",
                   // minimumResultsForSearch: -1
                });
                $(".select2-selection.select2-selection--multiple:not(:has(i.fa.fa-search.search-icon-input))").prepend("<i class='fa fa-search search-icon-input'></i>")

                $('#template_vendor_container').show();

                $('#template_vendor').unbind('select2:select').bind('select2:select', function () {
                    template_vendor = $(this).val();

                    if (template_vendor !== "") {
                        vendor_template_vendor_change($(this));
                    }
                });

                hide_overlay_loader('#vendor_template_modal .modal-content');
            },
            error: function (xhr) {
                ajax_error();
                debug(xhr.responseText);

                hide_overlay_loader('#vendor_template_modal .modal-content');
            }
        });
    };

    var vendor_template_vendor_change = function (select) {
        show_overlay_loader('#vendor_template_modal .modal-content');

        $.ajax({
            type: 'GET',
            url: 'vendor/template/' + template_market + '/' + template_vendor,
            dataType: 'json',
            encode: true,
            success: function (data) {

                if (template_media_type == 'tv') {
                    var template = $('#template_tv_container');
                    template_vendor_data = data;

                    template.find('#template_tv_vendor_callsign').html(data['callsign']);
                    if (data['branding'] !== "") {
                        template.find('#template_tv_vendor_branding').html(data['branding']);
                    } else {
                        template.find('#template_tv_vendor_branding').html('Not Available');
                    }
                    template.find('#template_tv_vendor_channel').html(data['channel']);
                    template.find('#template_tv_vendor_city').html(data['city']);
                    if (data['website'] !== "") {
                        template.find('#template_tv_vendor_website')
                            .html(data['website'] + '<i class="fa fa-external-link "></i>')
                            .attr('href', data['website']);
                    } else {
                        template.find('#template_tv_vendor_website')
                            .html('Not Available <i class="fa fa-external-link "></i>')
                            .attr('href', '#');
                    }

                    template.find('#template_tv_vendor_cbds')
                        .html('FCC CBDS <i class="fa fa-external-link "></i>')
                        .attr('href', 'https://transition.fcc.gov/fcc-bin/tvq?facid=' + data['facility_id']);
                    template.find('#template_tv_vendor_facility')
                        .html('FCC Facility Info <i class="fa fa-external-link "></i>')
                        .attr('href', 'https://enterpriseefiling.fcc.gov/dataentry/public/tv/publicFacilityDetails.html?facilityId=' + data['facility_id']);

                    var logos = template.find('#template_tv_vendor_logos');
                    logos.html('');

                    if (data['logos'].length !== 0) {
                        $.each(data['logos'], function (index, value) {
                            var add = value['path'].split("/");
                            add = "vendor_logos/" + add[2];
                            logos.append('<img src="/' + add + '" />');
                        });
                    } else {
                        logos.append('<p>No Logos available</p>');
                    }


                    var affils = template.find('#template_tv_vendor_affiliates');
                    affils.html('');
                    $.each(data['affiliates'], function (index, value) {
                        affils.append(value['name']);
                        if (index < (data['affiliates'].length - 1)) {
                            affils.append(', ');
                        }
                    });


                    $('#template_tv_map_container').html('<div style="height: 25vh; width: 23vw" class="leaflet-container" id="tv_map"></div>');

                    var src = /*window.location.hostname + */'/' + data['kml_file_path'];

                    //map = new google.maps.Map(document.getElementById('tv_map'));
                    map = new L.Map('tv_map');
                    L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
                        attribution: '&copy; <a href="http://openstreetmap.org">OpenStreetMap</a> contributors',
                        maxZoom: 18,
                    }).addTo(map);
                    map.attributionControl.setPrefix('');

                    console.log("MAP");
                    console.log(map);
                    console.log(src);

                    /*var kmlLayer = new google.maps.KmlLayer({
                        url: "http://" + src,
                        map: map,
                        preserveViewport: true
                    });*/

                    var kmlLayer = new L.KML(src, {async: true});
                    kmlLayer.on("loaded", function(e) {
                        map.fitBounds(e.target.getBounds());
                    });

                    map.addLayer(kmlLayer);

                    console.log("LAYER");
                    console.log(kmlLayer);

                    /*google.maps.event.addListener(kmlLayer, 'defaultviewport_changed', function () {
                        var bounds = kmlLayer.getDefaultViewport();
                        map.setCenter(bounds.getCenter());
                        map.setZoom(5);
                    });*/
                } else {
                    var template = $('#template_radio_container');
                    template_vendor_data = data;

                    template.find('#template_radio_vendor_callsign').html(data['callsign']);
                    if (data['branding'] !== "") {
                        template.find('#template_radio_vendor_branding').html(data['branding']);
                    } else {
                        template.find('#template_radio_vendor_branding').html('Not Available');
                    }
                    if (data['band'] == 'am') {
                        template.find('#template_radio_vendor_cbds')
                            .html('FCC CBDS <i class="fa fa-external-link "></i>')
                            .attr('href', 'https://transition.fcc.gov/fcc-bin/amq?list=0&facid=' + data['facility_id']);
                        template.find('#template_radio_vendor_frequency').html(data['frequency'] + ' kHz');
                        template.find('#template_radio_vendor_band').html('AM');
                    } else {
                        template.find('#template_radio_vendor_frequency').html(data['frequency'] + ' MHz');
                        template.find('#template_radio_vendor_cbds')
                            .html('FCC CBDS <i class="fa fa-external-link "></i>')
                            .attr('href', 'https://transition.fcc.gov/fcc-bin/fmq?list=0&facid=' + data['facility_id']);
                        template.find('#template_radio_vendor_band').html('FM');
                    }
                    template.find('#template_radio_vendor_city').html(data['city']);
                    if(typeof data['format'] !== 'undefined' && data['format'] !== null)
                        template.find('#template_radio_vendor_format').html(data['format']['name']);
                    if (data['website'] !== "") {
                        template.find('#template_radio_vendor_website')
                            .html(data['website'] + '<i class="fa fa-external-link "></i>')
                            .attr('href', data['website']);
                    } else {
                        template.find('#template_radio_vendor_website')
                            .html('Not Available <i class="fa fa-external-link "></i>')
                            .attr('href', '#');
                    }


                    var logos = template.find('#template_radio_vendor_logos');
                    logos.html('');

                    if (data['logos'].length !== 0) {
                        $.each(data['logos'], function (index, value) {
                            var add = value['path'].split("/");
                            add = "vendor_logos/" + add[2];
                            logos.append('<img src="/' + add + '" />');
                        });
                    } else {
                        logos.append('<p>No Logos available</p>');
                    }

                    $('#template_radio_map_container').html('<div style="height: 25vh; width: 23vw" class="leaflet-container"  id="radio_map"></div>');

                    var src = /*window.location.hostname + */'/' + data['kml_file_path'];

                    //map = new google.maps.Map(document.getElementById('radio_map'));
                    map = new L.Map('radio_map');
                    L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
                        attribution: '&copy; <a href="https://openstreetmap.org">OpenStreetMap</a> contributors',
                        maxZoom: 18,
                    }).addTo(map);
                    map.attributionControl.setPrefix('');

                    console.log("MAP");
                    console.log(map);
                    console.log(src);
                    /*var kmlLayer = new google.maps.KmlLayer({
                        url: src,
                        map: map
                    });*/
                    var kmlLayer = new L.KML(src, {async: true});
                    kmlLayer.on("loaded", function(e) {
                        map.fitBounds(e.target.getBounds());
                    });

                    map.addLayer(kmlLayer);

                    console.log("LAYER");
                    console.log(kmlLayer);
                    /*google.maps.event.addListener(kmlLayer, 'defaultviewport_changed', function () {
                        var bounds = kmlLayer.getDefaultViewport();
                        map.setCenter(bounds.getCenter());
                        map.setZoom(5);
                    });*/
                }

                $('#template_button_container').find('button').unbind('click').bind('click', function () {
                    template_vendor_submit();
                });

                $('#template_button_container_2').find('button').unbind('click').bind('click', function () {
                    export_vendor_submit();
                });

                if (template.is(':hidden')) {
                    template.slideDown();
                    $('#template_button_container').slideDown();
                    $('#template_button_container_2').slideDown();
                }

                hide_overlay_loader('#vendor_template_modal .modal-content');
            },
            error: function (xhr) {
                ajax_error();
                debug(xhr.responseText);

                hide_overlay_loader('#vendor_template_modal .modal-content');
            }
        });
    };

    var vendor_template_clear_tv_template = function () {
        container = $('#template_tv_container');
        container.slideUp();

        $('#template_button_container_div').css('display', 'block');
        $('#template_button_container_div_2').css('display', 'block');


            $('#template_button_container').slideUp();
            $('#template_button_container_2').slideUp();

        container.find('ul.list-icons').html('<li><i class="fa fa-caret-right fa-fw"></i> <strong id="template_tv_vendor_callsign"></strong></li> <li><i class="fa fa-caret-right fa-fw"></i> <span id="template_tv_vendor_branding"></span></li> <li><i class="fa fa-caret-right fa-fw"></i> Affiliates: <span id="template_tv_vendor_affiliates"></span></li> <li><i class="fa fa-caret-right fa-fw"></i> Channel: <span id="template_tv_vendor_channel"></span></li> <li><i class="fa fa-caret-right fa-fw"></i> Local City: <span id="template_tv_vendor_city"></span></li> <li><i class="fa fa-caret-right fa-fw"></i> <a href="" target="_blank" id="template_tv_vendor_website"></a></li> <li><i class="fa fa-caret-right fa-fw"></i> <a href="" target="_blank" id="template_tv_vendor_cbds"></a></li> <li><i class="fa fa-caret-right fa-fw"></i> <a href="" target="_blank" id="template_tv_vendor_facility"></a></li>');
        container.find('#template_tv_vendor_logos').html();

        container = $('#template_radio_container');
        container.slideUp();
        container.find('ul.list-icons').html('<li><i class="fa fa-caret-right fa-fw"></i> <strong id="template_radio_vendor_callsign"></strong></li> <li><i class="fa fa-caret-right fa-fw"></i> <span id="template_radio_vendor_branding"></span></li> <li><i class="fa fa-caret-right fa-fw"></i> <strong id="template_radio_vendor_band"></strong></li> <li><i class="fa fa-caret-right fa-fw"></i> Format: <span id="template_radio_vendor_format"></span></li> <li><i class="fa fa-caret-right fa-fw"></i> Frequency: <span id="template_radio_vendor_frequency"></span></li> <li><i class="fa fa-caret-right fa-fw"></i> Local City: <span id="template_radio_vendor_city"></span></li> <li><i class="fa fa-caret-right fa-fw"></i> <a href="" target="_blank" id="template_radio_vendor_website"></a></li> <li><i class="fa fa-caret-right fa-fw"></i> <a href="" target="_blank" id="template_radio_vendor_cbds"></a></li>');

        container.find('#template_radio_vendor_logos').html();
    };

    var exportToExcel = function(html){
        var url='data:application/vnd.ms-excel,' + encodeURIComponent(html);
        location.href=url;
        return false;
    }

    var export_vendor_submit = function(){
        if (template_media_type === 'tv') {
            var template = $('#template_tv_container');
            var tab = "<table>";
            tab += "<tr><td>CALLSIGN: </td><td>"+ template.find('#template_tv_vendor_callsign').html()+"</td></tr>";
            var bran = "Not available";
            if (template.find('#template_tv_vendor_branding').html() !== "") {
                bran = template.find('#template_tv_vendor_branding').html();
            }
            tab += "<tr><td>BRANDING: </td><td>"+ bran +"</td></tr>";
            tab += "<tr><td>CHANNEL: </td><td>"+ template.find('#template_tv_vendor_channel').html() +"</td></tr>";
            tab += "<tr><td>CITY: </td><td>"+ template.find('#template_tv_vendor_city').html() +"</td></tr>";
            tab += "<tr><td>WEBSITE: </td><td>"+ template.find('#template_tv_vendor_website').html() + "</td></tr>";
            tab += "<tr><td>FCC CBDS: </td><td>"+ template.find('#template_tv_vendor_cbds').attr('href') +"</td></tr>";
            tab += "<tr><td>FCC Facility Info: </td><td>"+ template.find('#template_tv_vendor_facility').attr('href') +"</td></tr>";
            tab += "<tr><td>AFFILIATES: </td><td>"+ template.find('#template_tv_vendor_affiliates').html() +"</td></tr>";
            tab += "</table>";

            exportToExcel(tab);

        }else{

            var template = $('#template_radio_container');
            var tab = "<table>";
            tab += "<tr><td>CALLSIGN: </td><td>"+ template.find('#template_radio_vendor_callsign').html() +"</td></tr>";
            var bran = "Not available";
            if (template.find('#template_radio_vendor_branding').html() !== "") {
                bran = template.find('#template_radio_vendor_branding').html();
            }
            tab += "<tr><td>BRANDING: </td><td>"+ bran +"</td></tr>";
            tab += "<tr><td>FCC CBDS: </td><td>"+ template.find('#template_radio_vendor_cbds').attr('href') +"</td></tr>";
            tab += "<tr><td>FREQUENCY: </td><td>"+ template.find('#template_radio_vendor_frequency').html() +"</td></tr>";
            tab += "<tr><td>BAND: </td><td>"+ template.find('#template_radio_vendor_band').html() +"</td></tr>";
            tab += "<tr><td>CITY: </td><td>"+ template.find('#template_radio_vendor_city').html() +"</td></tr>";
            tab += "<tr><td>FORMAT: </td><td>"+ template.find('#template_radio_vendor_format').html() +"</td></tr>";
            tab += "<tr><td>WEBSITE: </td><td>"+ template.find('#template_radio_vendor_website').html() +"</td></tr>";
            tab += "</table>";

            exportToExcel(tab);
        }
    };

    var template_vendor_submit = function () {
        show_overlay_loader('#vendor_template_modal .modal-content');
          var v_name= $("#template_vendor option:selected").html();

        $.ajax({
            type: 'GET',
            url: '/vendors/vendor_exits/' + v_name,
            dataType: 'json',
            encode: true,
            success: function (data) {
             if(data.data == null )
             {
                 form = $('#app-vendors-create-form');
                 template_reset_vendor_form();
                 if (template_media_type == 'tv') {
                     form.find('[name="vendor_type[]"]').val('tv');
                     template_reset_select2(form.find('[name="vendor_type[]"]'));
                     form.find('[name="vendor_name"]').val(template_vendor_data['callsign']);
                     form.find('[name="vendor_channel"]').val(template_vendor_data['channel']);
                     $.each(template_vendor_data['affiliates'], function (index, value) {
                         form.find('[name="vendor_affiliate"] option[value="' + value['slug'] + '"]').attr('selected', 'selected');
                     });
                     template_reset_select2(form.find('[name="vendor_affiliate"]'));
                     form.find('[name="vendor_markets[]"]').val(template_vendor_data['market']['slug']);
                     template_reset_select2(form.find('[name="vendor_markets[]"]'));

                     if (template_vendor_data['website'] !== '') {
                         form.find('[name="vendor_website"]').val(template_vendor_data['website']);
                     }
                     if (template_vendor_data['owner'] !== '') {
                         form.find('[name="vendor_owner"]').val(template_vendor_data['owner']);
                     }
                     form.find('#tv-options').slideDown();
                 } else {
                     form.find('[name="vendor_type[]"]').val('radio');
                     template_reset_select2(form.find('[name="vendor_type[]"]'));
                     form.find('[name="vendor_name"]').val(template_vendor_data['callsign']);
                     form.find('[name="vendor_frequency"]').val(template_vendor_data['frequency']);
                     if(template_vendor_data['format'] != null && template_vendor_data['format']['slug'] != null)
                         form.find('[name="vendor_format"]').val(template_vendor_data['format']['slug']);
                     template_reset_select2(form.find('[name="vendor_format"]'));
                     if(template_vendor_data['market'] != null)
                         form.find('[name="vendor_markets[]"]').val(template_vendor_data['market']['slug']);
                     template_reset_select2(form.find('[name="vendor_markets[]"]'));
                     if (template_vendor_data['website'] !== '') {
                         form.find('[name="vendor_website"]').val(template_vendor_data['website']);
                     }
                     form.find('#radio-options').slideDown();
                 }
                 $('#vendor_template_modal').modal('hide');
                 $('.panel-body').show();

             }
             else
                 global_notification('warning', 'This vendor already exists');
                hide_overlay_loader('#vendor_template_modal .modal-content');
            },
            error: function (xhr) {
              //  ajax_error();
              //  debug(xhr.responseText);
                hide_overlay_loader('#vendor_template_modal .modal-content');
            }
        });
    };

    function template_reset_vendor_form() {
        form = $('#app-vendors-create-form');
        form.find('[name="vendor_type[]"]').val('');
        form.find('[name="vendor_name"]').val('');
        form.find('[name="vendor_channel"]').val('');
        form.find('[name="vendor_affiliate"]').val('');
        form.find('#tv-options').slideUp();
        form.find('[name="vendor_frequency"]').val('');
        form.find('[name="vendor_format"]').val('');
        form.find('#radio-options').slideUp();
        form.find('[name="vendor_markets[]"]').val('');
        form.find('[name="vendor_website"]').val('');
        form.find('[name="vendor_owner"]').val('');
    }

    var template_reset_select2 = function (select) {
    	if (select.data('select2')) {
    		select.select2('destroy');
    	}
        select.select2({
            placeholder: "Select at least one.."
        });
        $(".select2-selection.select2-selection--multiple:not(:has(i.fa.fa-search.search-icon-input))").prepend("<i class='fa fa-search search-icon-input'></i>")
    };
}
